import Keycloak from 'keycloak-js';
import { PRODUCTION } from './global';

const keycloak = new Keycloak({
  url: 'https://apps.ilsp.gr:5500',
  realm: 'Justredi',
  clientId: PRODUCTION ? "Apps-justredi-data" : 'React-Auth'
});

export default keycloak;
